import React from "react";
import DashboardTabs, {
  DashboardTabItem,
} from "../../../../common/dashboard/DashboardTabs";
import { TabId } from "./types";
import { useCmpOrganizationNoun } from "../../../../../contexts/CmpOrganizationNounContext";

export const tabItems: DashboardTabItem<TabId>[] = [
  { id: "globalSettings", label: "Global Settings" },
  { id: "membershipSettings", label: "Membership Settings" },
  { id: "emailCommunications", label: "Automated Emails" },
  { id: "affinityProgramSetup", label: "Affinity Program Set Up" },
  { id: "governanceGroups", label: "Create Governance & Groups" },
  { id: "usersPermissions", label: "Create Employees and Permissions" },
];

const SettingsTabs = ({
  activeTab,
  items = tabItems,
  onTabChange,
}: {
  activeTab: TabId;
  items?: DashboardTabItem<TabId>[];
  onTabChange: (tabId: TabId) => void;
}) => {
  const noun = useCmpOrganizationNoun();

  return (
    <DashboardTabs
      // D@847394 (AE-13): the design tab bar on every tab.
      barClassName="mt-[24px] overflow-x-auto border-b border-[#ECECEC] bg-white"
      navClassName="flex min-w-max items-end gap-[24px]"
      getTabClassName={({ active }) => `border-b-2 pb-[12px] text-[14px] font-semibold leading-[18px] ${active ? "border-cpaGold text-cpaGold" : "border-transparent text-[#0A0A0A]"}`}
      activeTab={activeTab}
      ariaLabel={`${noun.Singular} settings tabs`}
      items={items}
      onTabChange={onTabChange}
    />
  );
};

export default SettingsTabs;
